import inputmask from "inputmask";

export const checkSMS = (input) => {
  const inputParent = input.closest(".input-container")
  const radioButton = inputParent.querySelector(".input-container__radio")
  inputmask('9999').mask(input)

  const acceptSMS = () => {
    const checkSMS = input.value.replace('_', '').length === 4
    checkSMS ? radioButton.classList.add('input-container__radio--valid') : radioButton.classList.remove('input-container__radio--valid')
    return checkSMS
  }

  return {
    acceptSMS
  }
  
}